import { Trans } from '@lingui/macro';
import { AppShell, createStyles, Flex, TFLogo, TFText, UnstyledButton } from '@tf/ui';
import type React from 'react';
import { Link } from 'react-router-dom';

const useStyles = createStyles(() => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		paddingLeft: '1rem',
		paddingRight: '1rem',
		background: 'transparent',
	},
}));

interface Props {
	withBorder?: boolean;
	style?: React.CSSProperties;
}
export const Footer: React.FC<Props> = ({ withBorder, style }) => {
	const { classes } = useStyles();

	return (
		<AppShell.Footer pos="relative" className={classes.root} h={70} withBorder={Boolean(withBorder)}>
			<Flex justify="center" w="100%" style={style}>
				<UnstyledButton target="_blank" to="https://trustform.io" component={Link}>
					<Flex align="center">
						<TFLogo size={18} />
						<TFText ml="8px" c="dimmed" size="14px">
							<Trans id="poweredByTrustform">Powered by Trustform</Trans>
						</TFText>
					</Flex>
				</UnstyledButton>
			</Flex>
		</AppShell.Footer>
	);
};
